import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import CartListingCart from "../CartListingCart";
import {
  LangContext,
  CartContext,
} from "../../../../../../../src/context/AppContext";
import { CircularProgress } from "@mui/material";
import { get_cartinfo } from "../../../../../../api/cart";

const HeaderCartIcon = () => {
  const [isLoading, setLoading] = useState(false);
  const { cartItemsQuantity, updateQuantity, updatecartItems, cartItems } =
    useContext(CartContext);

  const { selectedLanguage } = useContext(LangContext);
  const [data, setData] = useState({
    Items: [],
    TotalQuantity: 0,
  });

  const handle_cart = async () => {
    try {
      const response = await get_cartinfo(selectedLanguage);
      if (response.status) {
        setLoading(true);
        updateQuantity(response?.data?.total_quantity);
        updatecartItems(response?.data?.items);
        setData({
          Items: response?.data?.items,
          TotalQuantity: response?.data?.total_quantity,
        });
      }
    } catch (error) {
      console.log("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handle_cart();
  }, []);

  if (isLoading) {
    return (
      <div className="loading-container">
        <CircularProgress />
      </div>
    );
  }

  return (
    <div className="header-cart f-right pos-rel d-lg-block" id="topcarticon">
      <div className="lang-icon">
        <Link to="/cart">
          <ShoppingCartOutlinedIcon />
        </Link>
        <span>{cartItemsQuantity}</span>
      </div>

      {cartItemsQuantity > 0 && (
        <ul className="header-cart-list">
          {cartItemsQuantity > 0 ? (
            <>
              {cartItems?.slice(0, 5).map((cart, index) => (
                <li
                  key={index}
                  className={
                    index === cartItems.length - 1 || cartItems.length == 1
                      ? "no-border"
                      : ""
                  }
                >
                  <CartListingCart
                    cartimage={cart.healthpackage_image}
                    cartquantity={cart.cart_quantity}
                    cartname={cart.healthpackage_name}
                    cartprice={cart.healthpackage_price}
                  />
                </li>
              ))}
              <div className="view-cart-container">
                <Link to="/cart" className="view-cart-button">
                  View My Cart
                </Link>
              </div>
            </>
          ) : (
            <p></p>
          )}
        </ul>
      )}
    </div>
  );
};

export default HeaderCartIcon;
